export const selectedBtnStyle = {
  backgroundColor: '#198000',
  borderColor: 'transparent',
  color: '#fff',
  borderRadius: '50px',
};
